module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home-quote":"Your home insurance quote","motor-quote":"Your car insurance quote","ref":"Quote reference"}}')
  delete Component.options._Ctor
}
